// extracted by mini-css-extract-plugin
var _1 = "yHqMb";
var _2 = "bYxdu";
var _3 = "LMtWd";
var _4 = "x4iKB";
var _5 = "y6D9P";
var _6 = "O5HiY";
var _7 = "ZcJNu";
export { _1 as "buttonContainer", _2 as "container", _3 as "leaderboardHeading", _4 as "leaderboardTable", _5 as "pagination", _6 as "pointsText", _7 as "wrapper" }
